import React from "react";
import Input from "../../../../ui/common/Input";
import "./TentaclesSettingsForms.scss";
import { getFieldValue } from "../fieldValue";
import JsonArrayTextArea from "./JsonArrayTextArea";

const ClassificationsForm = ({ data, handleChanges }) => {
  return (
    <div className="inputs-container tentacles-classifications-form-container">
      <Input
        value={getFieldValue(data.classificationsUpdateRate)}
        type="number"
        onChange={(e) => {
          handleChanges("classificationsUpdateRate", e.target.valueAsNumber);
        }}
        label="Classifications Update Rate"
        fullWidth
        separateLines
      />
      <JsonArrayTextArea
        label="Clicks"
        value={getFieldValue(data.clicks)}
        onChange={(value) => {
          handleChanges("clicks", value);
        }}
      />
      <JsonArrayTextArea
        label="Loyalty"
        value={getFieldValue(data.loyalty)}
        onChange={(value) => {
          handleChanges("loyalty", value);
        }}
      />
    </div>
  );
};

export default ClassificationsForm;
